// extracted by mini-css-extract-plugin
module.exports = {"colorBlock":"ColorChooser_colorBlock__2rwcH","valueR":"ColorChooser_valueR__1SXFa","valueG":"ColorChooser_valueG__20yke","valueB":"ColorChooser_valueB__1Qz7m"};